// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    'use strict';
    $(document).ready(function () {

        $('.news-feed').each(function () {
            var vm = $(this);

            var highlight = false;
            if (!vm.find('.newsfeed_spot .grid_4:first-of-type').hasClass('twitter-block')) {
                highlight = vm.find('.newsfeed_spot .grid_4:first-of-type');
            }
            var items;
            if (highlight) {
                items = vm.find('.newsfeed_spot .grid_4').length + 2;
                if (items % 2 === 0) {
                    items++;
                }
            } else {
                items = vm.find('.newsfeed_spot .grid_4').length;
                if (items % 2 === 1) {
                    items++;
                }
            }
            var container = vm.find('.news-feed-container');
            var distance = vm.find('.newsfeed_spot .grid_4:first-of-type').width() + 20; // size of a single item
            var time = 400; // if configurable, take from Sitecore (data attributes)
            var canMove = true;
            var initialIndent = 150; // pushed a little so one can see there is content before as well

            if (vm.width() < 768) {
                initialIndent -= 129; // less indentation in mobile so that one block is fully visible from start
            }

            // First element is highlighted
            if (highlight) {
                highlight.addClass('highlight');
                highlight.removeClass('grid_4');
            }

            // Remove functionality if 5 or less items
            if (items < 9) {
                initialIndent = 0;
                vm.find('.slider-nav.left').hide();
                vm.find('.slider-nav.right').hide();

            } else {

                // Reel and parent widths ----------
                var reel = vm.find('.newsfeed_spot');
                reel.width(Math.round(items / 2 * 320) + 10);
                reel.clone().insertBefore(reel);
                vm.find('.news-feed-container').width(reel.width() * 2);

                // Initialize position ----------------
                var startingPoint = reel.width() - initialIndent;
                container.css('margin-left', '-' + startingPoint + 'px');

                // Add lazyload to all images and trigger loading ---------
                vm.find('img.lazy').lazyload({
                    event: "newsFeedTrigger"
                });
                vm.find('img.lazy').trigger("newsFeedTrigger");
            }

            var move = function (direction, speed) {
                container.animate({ 'margin-left': direction + '=' + speed + 'px' }, time, "swing");
            };

            // Button handling ----------------------------
            var moveLeft = function () {

                if (highlight) {
                    distance = distance * 3 / 2;
                }
                // Passing over the highlighted element at 2x speed (negative "string" handling)
                var doubleSpeed = distance - initialIndent + 10;
                var doubleSpeed2 = reel.width() + distance - initialIndent;

                // If at start and pressed left, go between the 2 reels (negative "string" handling)
                var resetPoint = distance - initialIndent + 10;
                if (highlight) {
                    distance = distance * 2 / 3;
                }
                var resetTo = reel.width() + distance - initialIndent;

                // If at start and pressed left, go between the 2 reels
                if (container.css('margin-left') === '-' + resetPoint + 'px') {
                    container.css('margin-left', '-' + resetTo + 'px');
                }

                if (canMove) {
                    // Passing over the highlighted element at 2x speed
                    if (container.css('margin-left') === '-' + doubleSpeed + 'px' || container.css('margin-left') === '-' + doubleSpeed2 + 'px') {
                        if (highlight) {
                            move('+', distance * 3 / 2);
                        } else {
                            move('+', distance);
                        }
                    } else {
                        move('+', distance);
                    }
                    canMove = false;
                    setTimeout(function () { canMove = true; }, time);
                }
            };
            var moveRight = function () {

                // Passing over the highlighted element at 2x speed (negative "string" handling)
                var doubleSpeed = 0 - initialIndent;
                var doubleSpeed2 = reel.width() - initialIndent;

                // If at end and pressed right, go between the 2 reels (negative "string" handling)
                var resetPoint = reel.width() * 2 - 1280 - initialIndent - 10;
                if (items == 9 && highlight) {
                    resetPoint = resetPoint - initialIndent - 10;
                }
                var resetTo = reel.width() - 1280 - initialIndent;
                // If at end and pressed right, go between the 2 reels
                if (container.css('margin-left') === '-' + resetPoint + 'px') {
                    container.css('margin-left', '-' + resetTo + 'px');
                }

                if (canMove) {
                    // Passing over the highlighted element at 2x speed
                    if (container.css('margin-left') === '-' + doubleSpeed + 'px' || container.css('margin-left') === '-' + doubleSpeed2 + 'px') {
                        if (highlight) {
                            move('-', distance * 3 / 2);
                        } else {
                            move('-', distance);
                        }
                    } else {
                        move('-', distance);
                    }
                    canMove = false;
                    setTimeout(function () { canMove = true; }, time);
                }
            };

            vm.find('.slider-nav.left').click(function () {
                moveLeft();
            });


            vm.find('.slider-nav.right').click(function () {
                moveRight();
            });

        });

    });
})(window, document, jQuery);